import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }

import CreateAndDeleteButtons from "@/components/AllowAccessOfficeParts/createOrDeleteButtons/CreateAndDeleteButtons.vue"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getAllowAccessOfficeResponse from "@/types/responses/getAllowAccessOffice"
import {
  SELECTABLE_STATUSES,
  ALL,
  COMPLETED,
  INCOMPLETED
} from "@/services/consts/allow_access_office";

type keyValue = {
  key: string | number,
  value: string | number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AllowAccessOfficesEditList',
  props: {
    allowAccessOffices: {},
    account: {},
    operationOffices: {},
    createAuthority: { type: Boolean },
    deleteAuthority: { type: Boolean },
    selectedStatusKey: {}
  },
  emits: ['inactiveModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

function filterAllowAccessOffice(operationOffice: getOperationOffice) {
  return props.allowAccessOffices.filter((allowAccessOffice) => {
    return allowAccessOffice.operation_office_id == operationOffice.id
  })
}

function filterByStatus(operationOffice: getOperationOffice) {
  if (props.selectedStatusKey.value == ALL) {
    return true
  }

  const exists: number = filterAllowAccessOffice(operationOffice).length
  if ((props.selectedStatusKey.value == COMPLETED && exists) ||
    (props.selectedStatusKey.value == INCOMPLETED && !exists)
  ) {
    return true
  }

  return false
}

function inactiveModal(isSucceeded: boolean) {
  emits('inactiveModal', isSucceeded)
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_table, { class: "border" }, {
    default: _withCtx(() => [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.operationOffices, (operationOffice, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            (filterByStatus(operationOffice))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("td", null, _toDisplayString(operationOffice.name), 1),
                  _createElementVNode("td", _hoisted_1, [
                    _createVNode(CreateAndDeleteButtons, {
                      accountId: props.account.id,
                      operationOfficeId: operationOffice.id,
                      allowAccessOffice: filterAllowAccessOffice(operationOffice),
                      createAuthority: props.createAuthority,
                      deleteAuthority: props.deleteAuthority,
                      onInactiveModal: inactiveModal
                    }, null, 8, ["accountId", "operationOfficeId", "allowAccessOffice", "createAuthority", "deleteAuthority"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})